// extracted by mini-css-extract-plugin
export var callCard = "_pg-0";
export var callMessageButton = "_pg-1";
export var helpIcon = "_pg-3";
export var helpIconContainer = "_pg-4";
export var verticalDivider = "_pg-2";